function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("rect", {
  id: "Rectangle_81193",
  "data-name": "Rectangle 81193",
  width: 25.11,
  height: 16.756,
  transform: "translate(0 0)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_18209",
  "data-name": "Group 18209",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_22439",
  "data-name": "Path 22439",
  d: "M12.555.01C3.451.336,0,8.38,0,8.38a15.042,15.042,0,0,0,12.555,8.376A13.538,13.538,0,0,0,25.11,8.386C20.224-.629,12.555.01,12.555.01M12.4,13.721a5.333,5.333,0,1,1,5.333-5.333A5.333,5.333,0,0,1,12.4,13.721"
}), React.createElement("path", {
  id: "Path_22440",
  "data-name": "Path 22440",
  d: "M12.4,5.324a3.188,3.188,0,1,0,3.188,3.188A3.188,3.188,0,0,0,12.4,5.324"
}));

var SvgVisible = function SvgVisible(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_18210",
    "data-name": "Group 18210",
    width: 25.11,
    height: 16.756,
    viewBox: "0 0 25.11 16.756",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVisible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Visible.9434b902.svg";
export { ForwardRef as ReactComponent };